import React, { useEffect, useState } from 'react';
import Breadcrumb from 'components/UI/molecules/Breadcrumb';
import DocumentCard from 'components/UI/molecules/DocumentCard';
import DocumentCardContainer from 'components/UI/molecules/DocumentCardContainer';
import MainHeadingText from 'components/UI/atoms/MainHeadingText';
import DashboardContentText from 'components/UI/atoms/DashboardContentText';
import DashboardContentHeading from 'components/UI/atoms/DashboardContentHeading';
import MainHeadingSeparator from 'components/UI/atoms/MainHeadingSeparator';
import StrokeText from 'components/UI/atoms/StrokeText';
import usePlatinumAwardState from 'hooks/student/usePlatinumAwardState';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BottomLandscapeCard from 'components/UI/molecules/BottomLandscapeCard';
import ModalUploader from 'components/UI/organisms/ModalUploader';
import FileUploadPanel from 'components/UI/organisms/FileUploadPanel';
import useFileUploadPanel from 'hooks/student/useFileUploadPanel';
import useAssignmentDocuments from 'hooks/student/useAssignmentDocuments';
import useDirectories from 'hooks/student/useDirectories';
import useUser from 'hooks/auth/useUser';
import AssignResourceAccordion from 'components/UI/organisms/AssignResourceAccordion';
import EvidenceRecordButton from 'components/UI/atoms/EvidenceRecordButton';
import UploadModalAsPanel from 'components/UI/organisms/UploadModalAsPanel';

function PlatinumAward() {
  const { userType } = useUser();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { histories } = useFileUploadPanel();
  const { getByPath } = useDirectories();
  const {
    slot1,
    slot2,
    slot3,
    slot4,
    slot1Input,
    slot2Input,
    slot3Input,
    slot4Input,
    removeSlot1,
    removeSlot2,
    removeSlot3,
    removeSlot4,
    targetSlot,
    handleLinkUpload,
  } = usePlatinumAwardState();
  const { list: assignmentDocuments } = useAssignmentDocuments();

  const breadcrumbsItems = [
    {
      text: 'ENGAGEMENT',
      path: '/engagement?folderId=' + getByPath('engagement')?.id,
    },
    {
      text: 'PLATINUM AWARD',
      path: '/engagement/platinum-award?folderId=' + searchParams.get('folderId'),
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const uploadModal = (type = null) => {
    setOpen(type);
    switch (type) {
      case 'slot1':
        targetSlot.current = 1;
        break;
      case 'slot2':
        targetSlot.current = 2;
        break;
      case 'slot3':
        targetSlot.current = 3;
        break;
      case 'slot4':
        targetSlot.current = 4;
        break;
    }
  };

  const handleUpload = (e) => {
    e.preventDefault();
    switch (open) {
      case 'slot1':
        slot1Input.click();
        break;
      case 'slot2':
        slot2Input.click();
        break;
      case 'slot3':
        slot3Input.click();
        break;
      case 'slot4':
        slot4Input.click();
        break;
    }
  };

  return (
    <div>
      <MainHeadingText>
        PLATINUM <br /> AWARD
      </MainHeadingText>
      <Breadcrumb prefix={true} items={breadcrumbsItems} />
      <MainHeadingSeparator />
      {userType === 'student' && (
        <>
          <FileUploadPanel
            title={() => (
              <>
                YOUR PROJECT <br /> PRESENTION
              </>
            )}
            activeFile={slot1}
            histories={histories}
            onUpload={() => uploadModal('slot1')}
            onRemoveHistory={removeSlot1}
          ></FileUploadPanel>
          <FileUploadPanel
            title={() => (
              <>
                YOUR PROJECT <br /> PROGRESS 2 SNAPSHOT
              </>
            )}
            activeFile={slot2}
            histories={histories}
            onUpload={() => uploadModal('slot2')}
            onRemoveHistory={removeSlot2}
          ></FileUploadPanel>
          <FileUploadPanel
            title={() => (
              <>
                YOUR PROJECT <br /> PROGRESS 1 SNAPSHOT
              </>
            )}
            activeFile={slot3}
            histories={histories}
            onUpload={() => uploadModal('slot3')}
            onRemoveHistory={removeSlot3}
          ></FileUploadPanel>
          <FileUploadPanel
            title={() => (
              <>
                YOUR PROJECT <br /> UPLOAD
              </>
            )}
            activeFile={slot4}
            histories={histories}
            onUpload={() => uploadModal('slot4')}
            onRemoveHistory={removeSlot4}
          ></FileUploadPanel>
          <EvidenceRecordButton />
        </>
      )}
      <DashboardContentText>
        The PLATINUM AWARD represents the highest Diploma Award and takes place during the first
        term of year 13 from September to December.
      </DashboardContentText>
      <DashboardContentText>
        The award is divided into two parts, a very high-level project followed by a work placement.
        The Platinum Award represents high levels of employability awareness and skills coupled with
        thorough understanding of how Self-Worth, Engagement and Purpose form the bedrock
        foundations of finding your place in a fast-changing working world.
      </DashboardContentText>
      <div style={{ height: 36 }} />
      {userType === 'student' ? (
        <>
          <DashboardContentHeading>ASSIGNMENT DOCUMENTS</DashboardContentHeading>
          {assignmentDocuments.length === 0 ? (
            <div className="py-[56px]">
              <StrokeText>
                No Assignment <br />
                Documents
              </StrokeText>
            </div>
          ) : (
            <DocumentCardContainer>
              {assignmentDocuments.map((item, index) => (
                <DocumentCard data={item} key={index} />
              ))}
            </DocumentCardContainer>
          )}
          <div className="flex flex-wrap  w-full justify-start gap-[72px] mt-[140px]">
            <BottomLandscapeCard
              title="VISIT THE EVIDENCE RECORD"
              buttonTitle="START"
              onClick={() => {
                navigate('/student/purpose/evidence-record');
              }}
            />
          </div>
        </>
      ) : (
        <>
          <AssignResourceAccordion />
          <UploadModalAsPanel />
        </>
      )}

      <ModalUploader
        open={!!open}
        setOpen={setOpen}
        handleUpload={handleUpload}
        handleLinkUploadFunc={handleLinkUpload}
      />
    </div>
  );
}

export default PlatinumAward;
